import { createSlice } from "@reduxjs/toolkit";
import { valentineInitialState } from "@/components/ValentinePopup/redux/initialState";
import ValentineReducer from "@/components/ValentinePopup/redux/reducers";

const valentineSlice = createSlice({
  name: "valentine",
  initialState: valentineInitialState,
  reducers: ValentineReducer,
});

export const { setError, setImageName, setIsImageGenerating, setIsOpenShareModal, setIsValentineModalOpen } =
  valentineSlice.actions;

export default valentineSlice.reducer;
